module.exports = {
  PG_CORE_URL: 'https://api-core.patientrewardshub.com',
  PG_COMM_URL: 'https://api-communications.patientrewardshub.com',
  MY_DOT_URL: {
    PRH: 'https://my.patientrewardshub.com',
    HUBBUX: 'https://my.hubbux.com',
    CULTURELLO: 'https://my.culturello.com',
  },
  SANITY_URL: 'https://practicegenius.sanity.studio',
  FILES_URL: 'https://files.patientrewardshub.com',
  BASE_URL: '',
  ASSETS_URL: 'https://sites-assets.patientrewardshub.com/assets',

  GOOGLE_MAPS_KEY: 'AIzaSyBjzPiPMIBYLCJ9_bcT_4l2wkUjDcJrdFY',
  PUSHER_KEY: '6a1480dff8c57c27367c',
  PUSHER_CLUSTER: 'us3',

  GOOGLE_RECAPTCHA_SITE_KEY: {
    PRH: '6LercfkcAAAAAAei2x1f6i9j0hstVrvm7zKUaGb1',
    HUBBUX: '6LcuGPYcAAAAAM5MFgZEboRxQ4mgXxJtf5GaXvwc',
    CULTURELLO: '6LcFWdoqAAAAAKwc5be95Zc6vLAer4rxZchtYtGW',
  },

  GIPHY_API_KEY: '1tHZt4wUmq2DsaSgkYXXzTa5TCpAZ3fu',
};

